import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { DeletionRequest } from '@recruitee/company-types';
import { HttpApiService } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class CompanyDeletionRequestHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public fetch(): Observable<DeletionRequest> {
    return this.httpApi.get('/deletion_requests/pending').pipe(map(data => data.deletionRequest));
  }

  public createDeletionRequest(secureChangeToken: string): Observable<void> {
    return this.httpApi.post('/deletion_requests', {}, { secureChangeToken });
  }
}
